<template>
	<v-snackbar elevation="2" timeout="-1" :value="displayedMessage.show" v-if="displayedMessage.show" text outlined bottom :color="displayedMessage.color">
		<v-row no-gutters align="center">
			<v-icon small :color="displayedMessage.color" class="pr-1 my-auto">{{ displayedMessage.icon }}</v-icon>
			<span class="subtitle-1 my-auto" v-if="displayedMessage.title">
				<strong>{{ displayedMessage.title }}</strong>
			</span>
		</v-row>
		<v-divider :class="'my-1 ' + displayedMessage.color" style="opacity: 0.42" v-if="displayedMessage.title && displayedMessage.text"></v-divider>
		<span v-if="displayedMessage.text" v-html="displayedMessage.text"></span>
		<v-row no-gutters>
			<v-col cols="12" xs="12" align="right">
				<v-btn @click="closeSystemMessage()" small :color="displayedMessage.color" :disabled="systemmessages_loading" :loading="systemmessages_loading">
					Ok
					<v-icon small class="pl-1">fas fa-check</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-snackbar>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		systemmessages_toread() {
			return this.$store.getters.getSystemMessagesToRead;
		},
		systemmessages_loading() {
			return this.$store.getters.systemmessages_loading;
		},
		displayedMessage() {
			let snack = {
				id: 0,
				text: "",
				title: "",
				color: null,
				icon: null,
				show: false,
			};
			if (this.systemmessages_toread.messages) {
				let last = this.systemmessages_toread.messages[0];
				if (last) {
					if (last.type == "warning") {
						snack.color = "warning";
						snack.icon = "fas fa-triangle-exclamation";
					} else {
						snack.color = "primary";
						snack.icon = "fas fa-circle-info";
					}
					snack.id = last.id;
					snack.title = last.title;
					snack.text = last.content;
					snack.show = true;
				}
			}
			return snack;
		},
	},
	methods: {
		closeSystemMessage() {
			this.$store.dispatch("closeSystemMessage", this.displayedMessage.id);
		},
	},
	created() {
		this.$store.dispatch("fetchSystemMessagesToRead");
	},
};
</script>
